import type { ErrorEvent } from "@sentry/react";

/**
 * Whether an event was synthesised by Sentry's `httpClientIntegration` for a
 * failed API request.
 *
 * The mechanism type is the reliable signal here. The message text is not,
 * because it's identical across every endpoint and status code.
 */
export const isHttpClientError = (event: ErrorEvent): boolean =>
  event.exception?.values?.some(
    (value) => value?.mechanism?.type === "http.client",
  ) ?? false;
